// Used to transform a string into a tag (e.g. "Play Now" -> "play_now")
export const sanitizeTag = (tag?: string | null) =>
  tag ? tag.replace(/ /g, "_").toLowerCase() : "";

// Used to group games without a tag
export enum GameTags {
  Untagged = "untagged",
  // other tags are dynamically defined in CMS (e.g play_now, comming_soon, etc...)
}
